export default import.meta.ROLLDOWN_FILE_URL_WHWYR9VTD7dEUiHz2n_ocA